import { render, staticRenderFns } from "./EnumerationIcon.vue?vue&type=template&id=679e0bc0&scoped=true&"
import script from "./EnumerationIcon.vue?vue&type=script&lang=js&"
export * from "./EnumerationIcon.vue?vue&type=script&lang=js&"
import style0 from "./EnumerationIcon.vue?vue&type=style&index=0&id=679e0bc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679e0bc0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TitleWithSubtitle: require('/vercel/path0/components/componentloader/TitleWithSubtitle.vue').default,IconCollection: require('/vercel/path0/components/general/IconCollection.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default})
